import { z } from 'zod';
import { coPilotOptionsSchema } from './copilot-options.schema';
import { routingOptionsSchema } from './routing-options.schema';
import { unitsOfMeasurementSchema } from './units-of-measurement.schema';
import { vehicleGroupsSchema } from './vehicle-groups.schema';
import { vehicleOptionsSchema } from './vehicle-options.schema';
import { vehicleTypeSchema } from './vehicle-type.schema';

export const routingProfileSchema = z.object({
  routingProfileId: z.number(),
  name: z.string().min(1),
  isAccountDefault: z.boolean(),
  vehicleType: vehicleTypeSchema,
  units: unitsOfMeasurementSchema,
  vehicleOptions: vehicleOptionsSchema.optional(),
  routingOptions: routingOptionsSchema,
  copilotOptions: coPilotOptionsSchema.optional(),
  vehicleGroups: vehicleGroupsSchema.optional(),
});

export const defaultRoutingProfileSchema = routingProfileSchema.extend({
  routingProfileId: z.number().optional(),
  isAccountDefault: z.boolean().optional(),
});

export const routingProfilesSchema = z.array(routingProfileSchema);

export type RoutingProfile = z.infer<typeof routingProfileSchema>;

export type RoutingProfiles = z.infer<typeof routingProfilesSchema>;

export type DefaultRoutingProfile = z.infer<typeof defaultRoutingProfileSchema>;
